import _toConsumableArray from "D:/daima/website/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import { ref, onMounted, computed, reactive } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useKnowledgeStore } from "../../../store/knowledge"; //引入news仓库

import { storeToRefs } from 'pinia'; //引入方法让仓库里的值可以解构赋值并且具有响应式

export default {
  name: "KnowledgeDetail",
  setup: function setup() {
    var store = useKnowledgeStore();
    var router = useRouter();
    var route = useRoute();
    onMounted(function () {
      //通知vuex发送请求获取新闻推荐的数据
      store.getKnowledgeRecommended();
    }); //数据
    //声明一个变量来接受新闻列表传过来的query参数包含 title、imgUrl、content、releaseDate 这四个参数

    var knowledgedetail = reactive({
      title: route.query.title,
      imgUrl: route.query.imgUrl,
      content: _toConsumableArray(JSON.parse(route.query.content)),
      releaseDate: route.query.releaseDate
    }); //接受新闻推荐的数据

    var _storeToRefs = storeToRefs(store),
        knowledgeRecommended = _storeToRefs.knowledgeRecommended; //方法
    //点击新闻推荐是修改页面数据


    function goRecommended(nr) {
      //滚动到详情位置.
      var goDetailTop = document.getElementById('long-left');
      goDetailTop.scrollIntoView({
        behavior: "smooth",
        //平滑滚动
        block: 'start' //将指定位置滚动到页面中间

      });
      knowledgedetail.title = nr.title;
      knowledgedetail.imgUrl = nr.bigImgUrl;
      knowledgedetail.content = nr.content;
      knowledgedetail.releaseDate = nr.releaseDate;
    } //跳转新闻列表


    function backNewsList() {
      router.push("/knowledge");
    } // 视频相关状态


    var showVideo = ref(false); // 控制视频弹窗显示

    var currentVideoUrl = ref(""); // 当前播放的视频地址
    // 播放视频

    var playVideo = function playVideo(url) {
      currentVideoUrl.value = url;
      showVideo.value = true; // 阻止页面滚动

      document.body.style.overflow = "hidden";
    }; // 关闭视频


    var closeVideo = function closeVideo() {
      showVideo.value = false;
      currentVideoUrl.value = ""; // 恢复页面滚动

      document.body.style.overflow = "auto";
    };

    return {
      knowledgedetail: knowledgedetail,
      knowledgeRecommended: knowledgeRecommended,
      goRecommended: goRecommended,
      backNewsList: backNewsList,
      showVideo: showVideo,
      currentVideoUrl: currentVideoUrl,
      playVideo: playVideo,
      closeVideo: closeVideo
    };
  }
};